import React from "react";
import moment from "moment";
import Tag from "../../../ui-components/molecules/tag/tag";
import { cn } from "../../../services/common/className";
import { TransactionMessageProcessingStatus } from "../../../app/data/transaction-monitor/models";
import XGSIcon from "../../../ui-components/icon/xgsIcon";
import XGSIcons from "../../../ui-components/icon/xgsIcons";

const getFormatteProcessingStatus = (status: TransactionMessageProcessingStatus) => {
  if (status === TransactionMessageProcessingStatus.SUCCESS) {
    return <Tag mix={cn("cell__processing-status")("success")}>
      {status}
    </Tag>;
  } else if (status === TransactionMessageProcessingStatus.ERROR) {
    return <Tag mix={cn("cell__processing-status")("error")}>
      {status} <XGSIcon icon={XGSIcons.faExternalLinkAlt} />
    </Tag>;
  } else if (status === TransactionMessageProcessingStatus.ACTIVE) {
    return <Tag mix={cn("cell__processing-status")("active")}>
      {status}
    </Tag>;
  } else {
    return <Tag mix={cn("cell__processing-status")("dropped")}>
      {status}
    </Tag>;
  }
}

const getFormattedIdAndRefType = (referenceTypeText: string) => {
  return <Tag mix="cell__id-ref-type">{referenceTypeText}</Tag>
}

export const getTransactionMessagesColumns = () => [
  {
    header: "Message ID",
    size: 40,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.references && cellProps.row.original.references[0]) ?
          cellProps.row.original.references[0].reference
          : ""
      }</>
    )
  },
  {
    header: "Message ID Type",
    size: 60,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.references && cellProps.row.original.references[0]) ?
          getFormattedIdAndRefType(cellProps.row.original.references[0].referenceTypeText)
          : ""
      }</>
    )
  },
  {
    header: "Ref No.",
    size: 40,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.references && cellProps.row.original.references[1]) ?
          cellProps.row.original.references[1].reference
          : ""
      }</>
    )
  },
  {
    header: "Ref No. Type",
    size: 60,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.references && cellProps.row.original.references[1]) ?
          getFormattedIdAndRefType(cellProps.row.original.references[1].referenceTypeText)
          : ""
      }</>
    )
  },
  {
    header: "Scope",
    size: 50,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.scope && cellProps.row.original.scope.name) ?
          cellProps.row.original.scope.name
          : ""
      }</>
    )
  },
  {
    header: "Message Types",
    size: 110,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.types && cellProps.row.original.types.length) ?
          cellProps.row.original.types[cellProps.row.original.types.length - 1].typeName.name
          : ""
      }</>
    )
  },
  {
    header: "Processing Status",
    size: 60,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.status && cellProps.row.original.status.processingStatus) ?
          getFormatteProcessingStatus(cellProps.row.original.status.processingStatus)
          : getFormatteProcessingStatus(TransactionMessageProcessingStatus.ACTIVE)
      }</>
    )
  },
  {
    header: "Flow",
    size: 70,
    cell: (cellProps: any) => (
      <>{
        (cellProps.row.original.flow && cellProps.row.original.flow.name) ?
          cellProps.row.original.flow.name
          : ""
      }</>
    )
  },
  {
    header: "Timestamp",
    size: 80,
    cell: (cellProps: any) => (
      <div className="cell__creation-details">
        <div className="created-at">
          {moment(cellProps.row.original.createdAt).format("MM/DD/YY HH:mm:ss")}
        </div>
        {
          (
            cellProps.row.original.createdBy
            && cellProps.row.original.createdBy.toUpperCase() !== "SYSTEM"
          ) && <div className="created-by">
            By: {cellProps.row.original.createdBy}
          </div>
        }
      </div>
    ),
  }
];
